<template>
  <div id="merchantInfo">
    <div class="header-nav flex-align">
      <img :src="themeData.darkLogoList">
      <div class="nav-right flex-align">
        <global-outlined class="ic-lanage" />
        <language-selector style="padding-left: 10px;" />
      </div>
    </div>
    <div class="merchant-body">
      <div class="body-left">
        <a-menu
          v-model:selectedKeys="selectedKeys"
          v-model:openKeys="openKeys"
          mode="inline"
          style="height: 100%"
          @click="({ key }) => handleNext(key)"
        >
          <a-sub-menu key="1">
            <template #title>{{ $t('pages_merchant_001') }}</template>
            <template #icon><form-outlined /></template>
            <a-menu-item key="1-1">
              <template #icon>
                <close-outlined v-if="stepIcons.companyNameInfo === 3" class="ic-error" />
                <check-outlined v-if="stepIcons.companyNameInfo === 2" class="ic-correct" />
              </template>
              {{ $t('pages_merchant_004') }}
            </a-menu-item>
            <a-menu-item key="1-2">
              <template #icon>
                <close-outlined v-if="stepIcons.parentCompanyInfo === 3" class="ic-error" />
                <check-outlined v-if="stepIcons.parentCompanyInfo === 2" class="ic-correct" />
              </template>
              {{ $t('pages_merchant_005') }}
            </a-menu-item>
            <a-menu-item key="1-3">
              <template #icon>
                <close-outlined v-if="stepIcons.branchOfficeSubsidiary === 3" class="ic-error" />
                <check-outlined v-if="stepIcons.branchOfficeSubsidiary === 2" class="ic-correct" />
              </template>
              {{ $t('pages_merchant_006') }}
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="2">
            <template #title>{{ $t('pages_merchant_002') }}</template>
            <template #icon><cloud-upload-outlined /></template>
            <a-menu-item key="2-1">
              <template #icon>
                <close-outlined v-if="stepIcons.businessLicenseInfo === 3" class="ic-error" />
                <check-outlined v-if="stepIcons.businessLicenseInfo === 2" class="ic-correct" />
              </template>
              <span>{{ $t('pages_merchant2_023') }}</span>
            </a-menu-item>
            <a-menu-item key="2-2">
              <template #icon>
                <close-outlined v-if="stepIcons.businessAddress === 3" class="ic-error" />
                <check-outlined v-if="stepIcons.businessAddress === 2" class="ic-correct" />
              </template>
              {{ $t('pages_merchant2_025') }}
            </a-menu-item>
            <a-menu-item key="2-3">
              <template #icon>
                <close-outlined v-if="stepIcons.identityInfo === 3" class="ic-error" />
                <check-outlined v-if="stepIcons.identityInfo === 2" class="ic-correct" />
              </template>
              {{ $t('pages_merchant_008') }}
            </a-menu-item>
            <a-menu-item key="2-4">
              <template #icon>
                <close-outlined v-if="stepIcons.personalInfo === 3" class="ic-error" />
                <check-outlined v-if="stepIcons.personalInfo === 2" class="ic-correct" />
              </template>
              {{ $t('pages_merchant_009') }}
            </a-menu-item>
            <a-menu-item key="2-5">
              <template #icon>
                <close-outlined v-if="stepIcons.resolutionPower === 3" class="ic-error" />
                <check-outlined v-if="stepIcons.resolutionPower === 2" class="ic-correct" />
              </template>
              {{ $t('pages_merchant_010') }}
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="4">
            <template #title>{{ $t('kyc_legal_record_menu') }}</template>
            <template #icon><video-camera-outlined /></template>
            <a-menu-item key="4-1">
              <template #icon>
                <close-outlined v-if="stepIcons.legalVideo === 3" class="ic-error" />
                <check-outlined v-if="stepIcons.legalVideo === 2" class="ic-correct" />
              </template>
              {{ $t('kyc_video_record') }}
            </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="3">
            <template #title>{{ $t('pages_merchant_003') }}</template>
            <template #icon><audit-outlined /></template>
            <!-- <a-menu-item key="3-1">
              <template #icon>
                <close-outlined v-if="stepIcons.sourceFundsInfo === 3" class="ic-error" />
                <check-outlined v-if="stepIcons.sourceFundsInfo === 2" class="ic-correct" />
              </template>
              {{ $t('pages_merchant_011') }}
            </a-menu-item> -->
            <a-menu-item key="3-2">
              <template #icon>
                <close-outlined v-if="stepIcons.sourceWhereabouts === 3" class="ic-error" />
                <check-outlined v-if="stepIcons.sourceWhereabouts === 2" class="ic-correct" />
              </template>
              {{ $t('pages_merchant_012') }}
            </a-menu-item>
            <a-menu-item key="3-3">
              <template #icon>
                <close-outlined v-if="stepIcons.clientInfo === 3" class="ic-error" />
                <check-outlined v-if="stepIcons.clientInfo === 2" class="ic-correct" />
              </template>
              {{ $t('pages_merchant2_036') }}
            </a-menu-item>
            <a-menu-item key="3-4">
              <template #icon>
                <close-outlined v-if="stepIcons.businessInfo === 3" class="ic-error" />
                <check-outlined v-if="stepIcons.businessInfo === 2" class="ic-correct" />
              </template>
              {{ $t('pages_merchant2_038') }}
            </a-menu-item>
            <a-menu-item key="3-5">
              <template #icon>
                <check-outlined v-if="stepIcons.otherInfo === 2" class="ic-correct" />
                <close-outlined v-if="stepIcons.otherInfo === 3" class="ic-error" />
              </template>
              {{ $t('pages_merchant_128') }}
            </a-menu-item>
            <!-- <a-menu-item v-if="risked" key="3-6">
              <close-outlined v-if="stepIcons.eddRefuseInfo === 3" class="ic-error" />
              <check-outlined v-if="stepIcons.eddRefuseInfo === 2" class="ic-correct" />
              EDD
            </a-menu-item> -->
            <a-menu-item key="3-7">
              <template #icon>
                <close-outlined v-if="stepIcons.declareInfo === 3" class="ic-error" />
                <check-outlined v-if="stepIcons.declareInfo === 2" class="ic-correct" />
              </template>
              {{ $t('pages_merchant_013') }}
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </div>
      <div class="body-right">
        <div style="width: 688px">
          <company-register
            v-if="selectedKeys.includes('1-1')"
            v-model:pattern="pattern"
            :model="companyNameInfo"
            :refused="refused"
            :countries="countries"
            @next="handleNext"
            @update="countryChange"
          />
          <company-parents
            v-if="selectedKeys.includes('1-2')"
            :model="parentCompanyInfo"
            :refused="refused"
            :countries="countries"
            @next="handleNext"
          />
          <company-sons
            v-if="selectedKeys.includes('1-3')"
            :model="branchOfficeSubsidiary"
            :refused="refused"
            :countries="countries"
            @next="handleNext"
          />
          <business-license
            v-if="selectedKeys.includes('2-1')"
            :model="businessLicenseInfo"
            :refused="refused"
            :country-code="companyNameInfo.countryCode"
            @next="handleNext"
          />
          <business-address
            v-if="selectedKeys.includes('2-2')"
            :model="businessAddress"
            :refused="refused"
            @next="handleNext"
          />
          <author-identity
            v-if="selectedKeys.includes('2-3')"
            :model="identityInfo"
            :refused="refused"
            :country-code="companyNameInfo.countryCode"
            @next="handleNext"
            @edit="identityChange"
          />
          <person-certificate
            v-if="selectedKeys.includes('2-4')"
            v-model:model="personalInfo"
            :refused="refused"
            :country-code="companyNameInfo.countryCode"
            :customer-identity="identityInfo.customerIdentity"
            :countries="countries"
            :refuse-attrs="refuseAttrs"
            @next="handleNext"
          />
          <resolution-power
            v-if="selectedKeys.includes('2-5')"
            :model="resolutionPower"
            :refused="refused"
            :theme-data="themeData"
            @next="handleNext"
          />
          <!-- <source-funds
            v-if="selectedKeys.includes('3-1')"
            :model="sourceFundsInfo"
            :refused="refused"
            @next="handleNext"
          /> -->
          <source-whereabouts
            v-if="selectedKeys.includes('3-2')"
            :model="sourceWhereabouts"
            :refused="refused"
            :risked="risked"
            @next="handleNext"
          />
          <client-info
            v-if="selectedKeys.includes('3-3')"
            :model="clientInfo"
            :refused="refused"
            :risked="risked"
            :countries="countries"
            @next="handleNext"
          />
          <business-info
            v-if="selectedKeys.includes('3-4')"
            :model="businessInfo"
            :refused="refused"
            :risked="risked"
            :countries="countries"
            @next="handleNext"
          />
          <other-funds
            v-if="selectedKeys.includes('3-5')"
            :model="otherInfo"
            :refused="refused"
            :risked="risked"
            @next="handleNext"
          />
          <risk-supply
            v-if="selectedKeys.includes('3-6')"
            :model="eddRefuseInfo"
            :refused="refused"
            :countries="countries"
            @next="handleNext"
          />
          <declare-page
            v-if="selectedKeys.includes('3-7')"
            ref="submitRef"
            :model="declareInfo"
            :refused="refused"
            :risked="risked"
            :theme-data="themeData"
            @next="handleNext"
            @finish="handleFinish"
          />
          <legal-video
            v-if="selectedKeys.includes('4-1')"
            :model="videoInfos"
            :refused="refused"
            @next="handleNext"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, reactive, toRefs, inject } from 'vue'
import { useRouter } from 'vue-router'
import { _user, _receive, _home } from '@/api'
import { message } from 'ant-design-vue'
import i18n from '@/locale'
import CompanyRegister from './components/company-register'
import CompanyParents from './components/company-parents'
import CompanySons from './components/company-sons'
import BusinessLicense from './components/business-license'
import BusinessAddress from './components/business-address'
import AuthorIdentity from './components/author-identity'
import PersonCertificate from './components/person-certificate'
import ResolutionPower from './components/resolution-power'
// import SourceFunds from './components/source-funds'
import SourceWhereabouts from './components/source-whereabouts'
import OtherFunds from './components/other-funds'
import DeclarePage from './components/declare-page'
import RiskSupply from './components/risk-supply'
import LangSelector from '@/components/lang-sel'
import ClientInfo from './components/client-info'
import BusinessInfo from './components/business-info'
import LegalVideo from './components/legal-video'

export default {
  name: 'MerchantInfo',
  components: {
    'company-register': CompanyRegister,
    'company-parents': CompanyParents,
    'company-sons': CompanySons,
    'business-license': BusinessLicense,
    'business-address': BusinessAddress,
    'author-identity': AuthorIdentity,
    'person-certificate': PersonCertificate,
    'resolution-power': ResolutionPower,
    // 'source-funds': SourceFunds,
    'source-whereabouts': SourceWhereabouts,
    'other-funds': OtherFunds,
    'declare-page': DeclarePage,
    'risk-supply': RiskSupply,
    'client-info': ClientInfo,
    'business-info': BusinessInfo,
    'legal-video': LegalVideo,
    'language-selector': LangSelector
  },
  setup () {
    const submitRef = ref(null)
    const router = useRouter()

    const state = reactive({
      themeData: inject('$themeData'),
      merchantNo: '',
      countries: [],
      notcountries: [],
      risked: false,
      refused: false,
      pattern: true,
      language: localStorage.getItem('locale-language') || 'zh',
      openKeys: ['1', '2', '3', '4'],
      selectedKeys: ['1-1'],
      refuseAttrs: [],
      stepIcons: {
        companyNameInfo: null,
        parentCompanyInfo: null,
        branchOfficeSubsidiary: null,
        businessLicenseInfo: null,
        businessAddress: null,
        identityInfo: null,
        personalInfo: null,
        resolutionPower: null,
        sourceFundsInfo: null,
        sourceWhereabouts: null,
        otherInfo: null,
        declareInfo: null,
        eddRefuseInfo: null,
        clientInfo: null,
        businessInfo: null,
        legalVideo: null
      },
      companyNameInfo: {
        countryCode: 'HK',
        countryCodeDisabled: false,
        countryCodeMessage: '',
        merchantNameEn: '',
        merchantNameEnDisabled: false,
        merchantNameEnMessage: '',
        merchantNameCn: '',
        merchantNameCnDisabled: false,
        merchantNameCnMessage: ''
      },
      parentCompanyInfo: {
        radioShow: '',
        radioShowDisabled: false,
        radioShowMessage: '',
        ownerShipPath: [], // 股权架构图
        ownerShipPathDisabled: false,
        ownerShipPathMessage: '',
        parentCertificatePath: [], // 母公司注册证明
        certificatePathDisabled: false,
        certificatePathMessage: '',
        parentNar1Path: [], // 母公司周年年报
        parentNar1PathDisabled: false,
        parentNar1PathMessage: '',
        parentUboCerPath: [], // 母公司UBO证明
        parentUboCerPathDisabled: false,
        parentUboCerPathMessage: '',
        tradeCountry: [{
          country: '', // 母公司注册国家
          name: '' // 母公司注册名称
        }],
        tradeCountryDisabled: false,
        tradeCountryMessage: '',
        parentHasLicense: '0',
        parentHasLicenseDisabled: false,
        parentHasLicenseMessage: ''
      },
      branchOfficeSubsidiary: {
        branchRadio: '',
        branchRadioDisabled: false,
        branchRadioMessage: '',
        branchCompanyCertificatePath: [], // 分公司注册证明
        branchCompanyCertificatePathDisabled: false,
        branchCompanyCertificatePathMessage: '',
        tradeCountry: [{
          country: '', // 子公司注册国家
          name: '' // 子公司注册名称
        }],
        tradeCountryDisabled: false,
        tradeCountryMessage: ''
      },
      businessLicenseInfo: {
        bizRegDate: '',
        bizRegDateDisabled: false,
        bizRegDateMessage: '',
        bizRegExpDate: '',
        bizRegExpDateDisabled: false,
        bizRegExpDateMessage: '',
        registrationAddress: '',
        registrationAddressDisabled: false,
        registrationAddressMessage: '',
        merchantRegistrationType: '',
        companyTypeDisabled: false,
        companyTypeMessage: '',
        bizRegID: '',
        bizRegIDDisabled: false,
        bizRegIDMessage: '',
        dirUBOChangeInYear: '0',
        dirUBOChangeInYearDisabled: false,
        dirUBOChangeInYearMessage: '',
        ciNumber: '',
        ciNumberDisabled: false,
        ciNumberMessage: '',
        taxNo: '',
        taxNoDisabled: false,
        taxNoMessage: '',
        ciPath: [],
        ciPathDisabled: false,
        ciPathMessage: '',
        bizRegProofPath: [],
        bizRegProofPathDisabled: false,
        bizRegProofPathMessage: '',
        nnc1Path2: [], // 法团成立表
        nnc1PathDisabled: false,
        nnc1PathMessage: '',
        corpConstPath: [], // 公司章程
        corpConstPathDisabled: false,
        corpConstPathMessage: '',
        shareCerPath: [],
        shareCerPathDisabled: false,
        shareCerPathMessage: '',
        goodStandingPath: [],
        goodStandingPathDisabled: false,
        goodStandingPathMessage: '',
        nar1Path2: [], // 周年年报
        nar1PathDisabled: false,
        nar1PathMessage: '',
        regApplyPath: [],
        regApplyPathDisabled: false,
        regApplyPathMessage: '',
        proxyProfPath: [],
        proxyProfPathDisabled: false,
        proxyProfPathMessage: '',
        directIncumPath: [], // 董事在职证明
        directIncumPathDisabled: false,
        directIncumPathMessage: '',
        sourceFundsPath: [], // 资金来源证明
        sourceFundsPathDisabled: false,
        sourceFundsPathMessage: '',
        companyAdditionalPath: [], // 公司附加证明
        companyAdditionalPathDisabled: false,
        companyAdditionalPathMessage: '',
        taxLicensePath: [],
        taxLicensePathDisabled: false,
        taxLicensePathMessage: '',
        annualReturnPath: [],
        annualReturnPathDisabled: false,
        annualReturnPathMessage: '',
        ownerShipPath: [],
        ownerShipPathDisabled: false,
        ownerShipPathMessage: ''

      },
      businessAddress: {
        companyAddressType: '',
        companyAddressTypeDisabled: false,
        companyAddressTypeMessage: '',
        realCompanyAddress: '', // 经营地址
        realCompanyAddressDisabled: false,
        realCompanyAddressMessage: '',
        bizAddrPath: [], // 商业地址证明
        bizAddrPathDisabled: false,
        bizAddrPathMessage: ''
      },
      identityInfo: {
        customerIdentityDisabled: false,
        customerIdentityMessage: '',
        customerIdentity: ['3']
      },
      personalInfo: {
        personalInfoDisabled: false,
        customer: [{
          collDisable: false,
          certificateType: '', // 0: 身份证 1: 护照
          nationality: '',
          idNumber: '',
          passportNumber: '',
          name: '',
          birthDate: '',
          certificateIssueDate: '',
          certificateDate: '',
          idPicFrontPath: [],
          idPicBackPath: [],
          passportPicPath: [],
          addressProofPath: [],
          holdingRatio: ''
        }],
        customerMessage: '',
        legalPerson: [{
          collDisable: false,
          certificateType: '', // 0: 身份证 1: 护照
          nationality: '',
          idNumber: '',
          passportNumber: '',
          name: '',
          birthDate: '',
          certificateIssueDate: '',
          certificateDate: '',
          idPicFrontPath: [],
          idPicBackPath: [],
          passportPicPath: [],
          addressProofPath: [],
          holdingRatio: ''
        }],
        legalPersonMessage: '',
        directorPerson: [{
          collDisable: false,
          certificateType: '', // 0: 身份证 1: 护照
          nationality: '',
          idNumber: '',
          passportNumber: '',
          name: '',
          birthDate: '',
          certificateIssueDate: '',
          certificateDate: '',
          idPicFrontPath: [],
          idPicBackPath: [],
          passportPicPath: [],
          addressProofPath: [],
          holdingRatio: ''
        }],
        directorPersonMessage: '',
        shareholder: [{
          collDisable: false,
          certificateType: '', // 0: 身份证 1: 护照
          nationality: '',
          idNumber: '',
          passportNumber: '',
          name: '',
          birthDate: '',
          certificateIssueDate: '',
          certificateDate: '',
          idPicFrontPath: [],
          idPicBackPath: [],
          passportPicPath: [],
          addressProofPath: [],
          holdingRatio: ''
        }],
        shareholderMessage: '',
        directorAddressProofPath: [], // 董事地址证明
        directorAddressProofPathDisabled: false,
        directorAddressProofPathMessage: ''
      },
      resolutionPower: {
        authorizationPath: [], // 董事会决议/授权书
        authorizationPathDisabled: false,
        authorizationPathMessage: ''
      },
      // sourceFundsInfo: {
      //   sourceFunds: [], // 运营资金来源
      //   sourceFundsDisabled: false,
      //   sourceFundsMessage: ''
      // },
      sourceWhereabouts: {
        paymentPurpose: [], // 预计付款目的
        sourceWhereaboutsDisabled: false,
        sourceWhereaboutsMessage: ''
      },
      videoInfos: {
        legalVideoPath: [],
        legalVideoPathDisabled: false,
        legalVideoPathMessage: '',
        rejectUpdated: false
      },
      otherInfo: {
        docDisabled: false,
        docMessage: '',
        docPath: [],
        supplyDisabled: false,
        supplyMessage: '',
        supplyText: ''
      },
      declareInfo: {
        declareRadio: '0',
        declareRadioDisabled: false,
        declareRadioMessage: '',
        tradeCountry: [{
          country: '', // 风险交易国家
          name: '' // 风险国家公司名称
        }],
        tradeCountryDisabled: false,
        tradeCountryMessage: '',
        checkOne: false,
        checkTwo: false
      },
      eddRefuseInfo: {
        customer: [{
          country: '',
          name: ''
        }],
        customerDisabled: false,
        customerMessage: '',
        supplier: [{
          country: '',
          name: ''
        }],
        supplierDisabled: false,
        supplierMessage: '',
        financialStatementsPath: [],
        statementsPathDisabled: false,
        statementsPathMessage: '',
        questionnairePath: [],
        questionnairePathDisabled: false,
        questionnairePathMessage: ''
      },
      clientInfo: {
        sourceOfCust: [],
        sourceOfCustDisabled: false,
        sourceOfCustMessage: '',
        countryOfCust: [],
        countryOfCustDisabled: false,
        countryOfCustMessage: '',
        suppliersCountry: [],
        suppliersCountryDisabled: false,
        suppliersCountryMessage: ''
      },
      businessInfo: {
        openingPurpose: [],
        openingPurposeDisabled: false,
        openingPurposeMessage: '',
        businessNatureType: [],
        businessNatureTypeDisabled: false,
        businessNatureTypeMessage: '',
        natures: [],
        naturesDisabled: false,
        naturesMessage: '',
        webSiteOrApp: '',
        webSiteOrAppDisabled: false,
        webSiteOrAppMessage: '',
        bizScopeDesc: '',
        bizScopeDescDisabled: false,
        bizScopeDescMessage: '',
        monthlyTxnCount: '',
        monthlyTxnCountDisabled: false,
        monthlyTxnCountMessage: '',
        monthlyTxnEst: '',
        monthlyTxnEstDisabled: false,
        monthlyTxnEstMessage: '',
        otherAccountPath: [],
        otherAccountPathDisabled: false,
        otherAccountPathMessage: '',
        shopProofPath: [],
        shopProofPathDisabled: false,
        shopProofPathMessage: '',
        companyWebsite: '',
        companyWebsiteDisabled: false,
        companyWebsiteMessage: '',
        bizCountry: [],
        bizCountryDisabled: false,
        bizCountryMessage: '',
        sourceFunds: [],
        sourceFundsDisabled: false,
        sourceFundsMessage: '',
        wealthSource: [],
        wealthSourceDisabled: false,
        wealthSourceMessage: ''
      }
    })

    const handleNext = (key) => {
      // according current step to verify
      switch (state.selectedKeys[0]) {
        case '1-1':
          if (!verifyCompanyNameInfo(state.companyNameInfo)) {
            state.stepIcons.companyNameInfo = 2
          } else {
            state.stepIcons.companyNameInfo = 3
          }
          break
        case '1-2':
          if (!verifyParentCompanyInfo(state.parentCompanyInfo)) {
            state.stepIcons.parentCompanyInfo = 2
          } else {
            state.stepIcons.parentCompanyInfo = 3
          }
          break
        case '1-3':
          if (!verifyBranchOfficeSubsidiary(state.branchOfficeSubsidiary)) {
            state.stepIcons.branchOfficeSubsidiary = 2
          } else {
            state.stepIcons.branchOfficeSubsidiary = 3
          }
          break
        case '2-1':
          if (!verifyBusinessLicenseInfo(state.businessLicenseInfo)) {
            state.stepIcons.businessLicenseInfo = 2
          } else {
            state.stepIcons.businessLicenseInfo = 3
          }
          break
        case '2-2':
          if (!verifyBusinessAddress(state.businessAddress)) {
            state.stepIcons.businessAddress = 2
          } else {
            state.stepIcons.businessAddress = 3
          }
          break
        case '2-3':
          if (!verifyIdentityInfo(state.identityInfo)) {
            state.stepIcons.identityInfo = 2
          } else {
            state.stepIcons.identityInfo = 3
          }
          break
        case '2-4':
          if (!verifyPersonInfo(state.personalInfo)) {
            state.stepIcons.personalInfo = 2
          } else {
            state.stepIcons.personalInfo = 3
          }
          break
        case '2-5':
          if (!verifyResolutionPower(state.resolutionPower)) {
            state.stepIcons.resolutionPower = 2
          } else {
            state.stepIcons.resolutionPower = 3
          }
          break
        // case '3-1':
        //   if (!verifySourceFundsInfo(state.sourceFundsInfo)) {
        //     state.stepIcons.sourceFundsInfo = 2
        //   } else {
        //     state.stepIcons.sourceFundsInfo = 3
        //   }
        //   break
        case '3-2':
          if (!verifySourceWhereabouts(state.sourceWhereabouts)) {
            state.stepIcons.sourceWhereabouts = 2
          } else {
            state.stepIcons.sourceWhereabouts = 3
          }
          break
        case '3-3':
          if (!verifyClientInfo(state.clientInfo)) {
            state.stepIcons.clientInfo = 2
          } else {
            state.stepIcons.clientInfo = 3
          }
          break
        case '3-4':
          if (!verifyBusinessInfo(state.businessInfo)) {
            state.stepIcons.businessInfo = 2
          } else {
            state.stepIcons.businessInfo = 3
          }
          break
        case '3-5':
          if (!verifyOtherInfo(state.otherInfo)) {
            state.stepIcons.otherInfo = 2
          } else {
            state.stepIcons.otherInfo = 3
          }
          break
        case '3-6':
          if (!verifyEddRefuseInfo(state.eddRefuseInfo)) {
            state.stepIcons.eddRefuseInfo = 2
          } else {
            state.stepIcons.eddRefuseInfo = 3
          }
          break
        case '3-7':
          if (!verifyDeclareInfo(state.declareInfo)) {
            state.stepIcons.declareInfo = 2
          } else {
            state.stepIcons.declareInfo = 3
          }
          break
        case '4-1':
          if (!verifyLegalVideo(state.videoInfos)) {
            state.stepIcons.legalVideo = 2
          } else {
            state.stepIcons.legalVideo = 3
          }
          break
      }
      state.selectedKeys = [key]
      setTemporaryValue()
    }

    const verifyCompanyNameInfo = (value, data) => {
      console.log('verifyCompanyNameInfo:', value, data)
      const { countryCode, merchantNameEn, merchantNameCn } = value || state.companyNameInfo

      if (countryCode && merchantNameEn && state.pattern && (countryCode === 'CN' ? merchantNameCn : true)) {
        if (data) {
          data.countryCode = countryCode
          data.merchantNameEn = merchantNameEn
          data.merchantName = merchantNameCn
        }
        // state.companyNameInfo.icon = 2
        console.log('verifyCompanyNameInfo pass')
      } else {
        // state.companyNameInfo.icon = null
        return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_004'))
      }
    }

    const verifyParentCompanyInfo = (value, data) => {
      console.log('verifyParentCompanyInfo:', value, data)
      const { parentHasLicense, radioShow, tradeCountry, ownerShipPath, parentCertificatePath, parentNar1Path, parentUboCerPath } = value || state.parentCompanyInfo
      if (radioShow === '1') {
        if (ownerShipPath.length === 0 || parentCertificatePath === 0 || parentUboCerPath === 0 || tradeCountry.some(item => (!item.country || !item.name))) {
          state.parentCompanyInfo.icon = null
          return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_005'))
        }

        // state.parentCompanyInfo.icon = 2

        if (data) {
          data.isParentCertificate = radioShow
          data.parentCertificatePath = parentCertificatePath
          data.ownerShipPath = ownerShipPath
          data.parentNar1Path = parentNar1Path
          data.parentUboCerPath = parentUboCerPath
          data.parentCertificate = tradeCountry.map(item => {
            return {
              parentCertificateName: item.name,
              parentCertificateCountry: item.country
              // parentHasLicense: item.hasLicense
            }
          })
          data.parentHasLicense = parentHasLicense
        }
      } else if (radioShow === '0') {
        if (data) {
          data.isParentCertificate = '0'
        }
        // state.parentCompanyInfo.icon = 2
      } else {
        // state.parentCompanyInfo.icon = null
        return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_005'))
      }
    }

    const verifyBranchOfficeSubsidiary = (value, data) => {
      console.log('verifyBranchOfficeSubsidiary:', value, data)
      const { branchRadio, tradeCountry, branchCompanyCertificatePath } = value || state.branchOfficeSubsidiary
      const flash = tradeCountry.some(item => (!item.country || !item.name))
      if ((branchRadio === '1' && !flash) || branchRadio === '0') {
        // state.branchOfficeSubsidiary.icon = 2
        if (data) {
          data.isResides = branchRadio
          data.branchCompanyCertificatePath = branchCompanyCertificatePath
          data.resides = tradeCountry.map(item => {
            return {
              residesName: item.name,
              residesCountry: item.country
            }
          })
        }
      } else {
        // state.branchOfficeSubsidiary.icon = null
        return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_006'))
      }
    }

    const verifyBusinessLicenseInfo = (value, data) => {
      console.log('verifyBusinessLicenseInfo:', value, data)
      const { bizRegDate, bizRegExpDate, registrationAddress, merchantRegistrationType, bizRegProofPath, bizRegID, ciNumber, dirUBOChangeInYear,
        ciPath, nnc1Path2, corpConstPath, shareCerPath, goodStandingPath, nar1Path2, regApplyPath, proxyProfPath, taxNo, directIncumPath, sourceFundsPath, companyAdditionalPath, taxLicensePath, annualReturnPath, ownerShipPath } = value || state.businessLicenseInfo

      const reportError = (step) => {
        console.log('reportError:', step)
        // state.businessLicenseInfo.icon = null
        return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant2_023'))
      }
      // necessary fields check
      if (!bizRegDate || !bizRegExpDate || !registrationAddress || !merchantRegistrationType || !bizRegID || bizRegProofPath.length === 0) {
        return reportError(0)
      }

      if (state.companyNameInfo.countryCode === 'HK') {
        if (!ciNumber || ciPath.length === 0 || nnc1Path2.length === 0 || corpConstPath.length === 0) {
          return reportError(1)
        }
      }

      if (['US', 'GB'].includes(state.companyNameInfo.countryCode)) {
        if (!taxNo) {
          return reportError(2)
        }
      }

      if (!['HK', 'CN'].includes(state.companyNameInfo.countryCode)) {
        if (!ownerShipPath || ownerShipPath.length === 0) {
          return reportError(3)
        }
      }

      if (!['CN'].includes(state.companyNameInfo.countryCode)) {
        if (corpConstPath.length === 0) {
          return reportError(4)
        }
      }

      // if (['VG', 'KY'].includes(state.companyNameInfo.countryCode)) {
      //   if (goodStandingPath.length === 0) {
      //     return reportError(4)
      //   }
      // }

      // if (!['HK', 'CN', 'US', 'IT', 'SG', 'PH', 'VG', 'KY'].includes(state.companyNameInfo.countryCode)) {
      //   if (regApplyPath.length === 0) {
      //     return reportError(5)
      //   }
      // }

      // if (['PH', 'VG', 'KY'].includes(state.companyNameInfo.countryCode)) {
      //   if (shareCerPath.length === 0) {
      //     return reportError(6)
      //   }
      // }

      // state.businessLicenseInfo.icon = 2
      if (data) {
        data.establishDate = bizRegDate
        data.brExpiryDate = bizRegExpDate
        data.registrationAddress = registrationAddress
        data.merchantRegistrationType = merchantRegistrationType
        data.companyType = merchantRegistrationType
        data.taxNo = taxNo
        data.dirUBOChangeInYear = dirUBOChangeInYear
        switch (state.companyNameInfo.countryCode) {
          case 'CN':
            data.businessLicensePath = bizRegProofPath
            data.businessLicenseCertificateNumber = bizRegID
            break
          case 'HK':
            data.businessRegistrationCertificatePath = bizRegProofPath
            data.businessRegistrationNumber = bizRegID
            break
          default:
            data.incorporationPath = bizRegProofPath
            data.companyRegistrationCertificateNumber = bizRegID
            break
        }
        data.companyCertificatePath = ciPath
        data.nnc1Path2 = nnc1Path2
        data.nnc1Path = nnc1Path2
        data.companyCertificateCINumber = ciNumber
        data.mermorandumPath = corpConstPath
        data.shareCerPath = shareCerPath
        data.goodstandPath = goodStandingPath
        data.nar1Path2 = nar1Path2
        data.nar1Path1 = nar1Path2
        data.regApplyPath = regApplyPath
        data.proxyProfPath = proxyProfPath
        data.directIncumPath = directIncumPath
        data.sourceFundsPath = sourceFundsPath
        data.companyAdditionalPath = companyAdditionalPath
        data.taxLicensePath = taxLicensePath
        data.annualReturnPath = annualReturnPath
        data.ownerShipPath = ownerShipPath
      }
    }

    const verifyBusinessAddress = (value, data) => {
      console.log('verifyBusinessAddress:', value, data)
      const { companyAddressType, realCompanyAddress, bizAddrPath } = value || state.businessAddress
      if (companyAddressType && realCompanyAddress && bizAddrPath.length !== 0) {
        if (data) {
          data.companyAddressType = companyAddressType
          data.registrationAddress = realCompanyAddress
          data.proofOfRealBusinessAddress = bizAddrPath
          data.mailingAddress = realCompanyAddress
        }
        // state.businessAddress.icon = 2
      } else {
        // state.businessAddress.icon = null
        return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant2_025'))
      }
    }

    const verifyIdentityInfo = (value, data) => {
      console.log('verifyIdentityInfo:', value, data)
      const { customerIdentity } = value || state.identityInfo
      if (customerIdentity.length !== 0) {
        // state.identityInfo.icon = 2
        if (data) data.customerIdentity = customerIdentity
      } else {
        // state.identityInfo.icon = null
        return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_008'))
      }
    }

    const verifyPersonInfo = (value, data) => {
      console.log('verifyPersonInfo:', value, data)
      const { customer, legalPerson, directorPerson, shareholder, directorAddressProofPath } = value || state.personalInfo
      const reportError = (debugMsg) => {
        // state.personalInfo.icon = null
        console.log('reportError:', debugMsg)
        return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_009'))
      }

      const necessaryFieldsCheck = (item) => {
        if (!item.certificateType || !item.nationality || !item.name || !item.birthDate || !item.certificateIssueDate || !item.certificateDate) {
          return reportError('necessaryFieldsCheck:' + JSON.stringify(item))
        }
      }

      const idPathCheck = (item) => {
        if (item.certificateType === '0') {
          if (!item.idNumber || item.idPicFrontPath.length === 0 || item.idPicBackPath.length === 0) {
            return reportError('idPathCheck id')
          }
        } else {
          if (!item.passportNumber || item.passportPicPath.length === 0) {
            return reportError('idPathCheck passport')
          }
        }
      }

      const addressProofPathCheck = (item) => {
        if (['PH', 'VG', 'KY'].includes(state.companyNameInfo.countryCode)) {
          if (item.addressProofPath.length === 0) {
            return reportError('addressProofPathCheck')
          }
        }
      }

      const buildIdPath = (item) => {
        return item.certificateType === '0' ? item.idPicFrontPath.concat(item.idPicBackPath) : item.passportPicPath
      }

      const getIdNo = (item) => {
        return item.certificateType === '0' ? item.idNumber : item.passportNumber
      }

      let dataCustomer = null
      let dataLegalPerson = null
      let dataDirectorPerson = null
      let dataShareholder = null
      // check customer
      if (data) {
        dataCustomer = []
        dataLegalPerson = []
        dataDirectorPerson = []
        dataShareholder = []
      }
      for (const item of customer) {
        // necessary fields check
        let errMsg = necessaryFieldsCheck(item)
        if (errMsg) {
          return errMsg
        }
        errMsg = idPathCheck(item)
        if (errMsg) {
          return errMsg
        }
        if (dataCustomer) {
          dataCustomer.push({
            customerType: item.certificateType,
            customerIssuancePlace: item.nationality,
            authorizedPerson: item.name, // ???
            dateOfBirthOfAuthorizedPerson: item.birthDate,
            authorizersCertificateDate: item.certificateDate,
            authorizersCerIssueDate: item.certificateIssueDate,
            iDNumberOfAuthorizedPerson: getIdNo(item),
            customerIDPath: buildIdPath(item)
          })
        }
      }

      // check legalPerson for CN
      if (state.companyNameInfo.countryCode === 'CN') {
        for (const item of legalPerson) {
          // necessary fields check
          let errMsg = necessaryFieldsCheck(item)
          if (errMsg) {
            return errMsg
          }
          errMsg = idPathCheck(item)
          if (errMsg) {
            return errMsg
          }
          if (dataLegalPerson) {
            dataLegalPerson.push({
              legalPersonCertificateType: item.certificateType,
              legalPersonCertificateIssuancePlace: item.nationality,
              corporateDirectorName: item.name,
              corporateDirectorDateOfBirth: item.birthDate,
              corporateDirectorCertificateIssueDate: item.certificateIssueDate,
              corporateDirectorCertificateExpiryDate: item.certificateDate,
              corporateDirectorIDNumber: getIdNo(item),
              legalPersonCertificatePath: buildIdPath(item)
            })
          }
        }
      } else {
        // check directorPerson
        for (const item of directorPerson) {
          // necessary fields check
          let errMsg = necessaryFieldsCheck(item)
          if (errMsg) {
            return errMsg
          }
          errMsg = idPathCheck(item)
          if (errMsg) {
            return errMsg
          }
          errMsg = addressProofPathCheck(item)
          if (errMsg) {
            return errMsg
          }
          if (dataDirectorPerson) {
            dataDirectorPerson.push({
              directorCertificateType: item.certificateType,
              directorCertificateIssuancePlace: item.nationality,
              directorName: item.name,
              directorDateOfBirth: item.birthDate,
              directorCertificateIssueDate: item.certificateIssueDate,
              directorCertificateExpiryDate: item.certificateDate,
              directorIDNumber: getIdNo(item),
              directorCertificatePath: buildIdPath(item)
            })
          }
        }
      }

      // check shareholder
      for (const item of shareholder) {
        // necessary fields check
        let errMsg = necessaryFieldsCheck(item)
        if (errMsg) {
          return errMsg
        }
        errMsg = idPathCheck(item)
        if (errMsg) {
          return errMsg
        }
        errMsg = addressProofPathCheck(item)
        if (errMsg) {
          return errMsg
        }
        if (dataShareholder) {
          dataShareholder.push({
            shareholderCertificateType: item.certificateType,
            shareholderCertificateIssuancePlace: item.nationality,
            ultimateBeneficiaryName: item.name,
            ultimateBeneficiaryDateOfBirth: item.birthDate,
            ultimateBeneficiaryHoldRatio: item.holdingRatio,
            ultimateBeneficiaryIssueDate: item.certificateIssueDate,
            ultimateBeneficiaryCertificateExpiryDate: item.certificateDate,
            ultimateBeneficiaryIDNumber: getIdNo(item),
            shareholderCertificatePath: buildIdPath(item)
          })
        }
      }

      if (data) {
        data.customer = dataCustomer
        data.legalPerson = dataLegalPerson
        data.director = dataDirectorPerson
        data.shareholder = dataShareholder
        data.directorAddressProofPath = directorAddressProofPath
      }
      // state.personalInfo.icon = 2
    }

    const verifyResolutionPower = (value, data) => {
      console.log('verifyResolutionPower:', value, data)
      const { authorizationPath } = value || state.resolutionPower
      if (authorizationPath.length !== 0) {
        if (data) {
          data.authorizationPath = authorizationPath
        }
      } else {
        // state.resolutionPower.icon = null
        // return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_010'))
      }
    }

    const verifySourceFundsInfo = (value, data) => {
      // console.log('verifySourceFundsInfo:', value, data)
      // const { sourceFunds } = value || state.sourceFundsInfo
      // if (sourceFunds.length !== 0) {
      //   if (data) {
      //     data.wealthSource = sourceFunds
      //   }
      // } else {
      //   // state.sourceFundsInfo.icon = null
      //   return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_011'))
      // }
    }

    const verifySourceWhereabouts = (value, data) => {
      // console.log('verifySourceWhereabouts:', value, data)
      // const { paymentPurpose } = value || state.sourceWhereabouts
      // if (paymentPurpose.length !== 0) {
      //   if (data) {
      //     data.paymentPurpose = paymentPurpose
      //   }
      // } else {
      //   // state.sourceWhereabouts.icon = null
      //   return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_012'))
      // }
    }

    const verifyOtherInfo = (value, data) => {
      console.log('verifyOtherInfo:', value, data)
      const { docPath, supplyText } = value || state.otherInfo
      if (data) {
        data.accessories = docPath
        data.approvePurpose = supplyText
      }
      // state.otherInfo.icon = 2
    }

    const verifyLegalVideo = (value, data) => {
      console.log('verifyLegalVideo:', value, data)
      const { legalVideoPath } = value || state.videoInfos
      if (legalVideoPath.length !== 0) {
        if (data) {
          data.legalVideoPath = legalVideoPath
        }
      } else {
        // if register country is non-CN, must upload video
        // if (state.companyNameInfo.countryCode !== 'CN') {
        //   return (i18n.global.t('common_text_047') + i18n.global.t('kyc_legal_video_title'))
        // }
      }
    }

    const verifyDeclareInfo = (value, data) => {
      console.log('verifyDeclareInfo:', value, data)
      const { declareRadio, tradeCountry, checkOne, checkTwo } = value || state.declareInfo
      if (!checkOne || !checkTwo) {
        return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant2_058'))
      }

      if (data) {
        data.isRiskCountryTransaction = declareRadio
        data.riskTransaction = tradeCountry.map(item => {
          return {
            riskTransactionCompanyName: item.name,
            riskTransactionCountry: item.country
          }
        })
      }
    }

    const verifyEddRefuseInfo = (value, data) => {
      console.log('verifyEddRefuseInfo:', value, data)
      // const { financialStatementsPath, questionnairePath, customer, supplier } = value || state.eddRefuseInfo
      // const flash1 = customer.some(item => (!item.country || !item.name))
      // const flash2 = supplier.some(item => (!item.country || !item.name))
      // if (state.risked && (questionnairePath.length === 0 || flash1 || flash2)) {
      //   return (i18n.global.t('common_text_047') + 'EDD')
      // } else if (data) {
      //   data.financialStatementsPath = financialStatementsPath
      //   data.questionnairePath = questionnairePath
      //   data.bestPerformingClient = customer.map(item => {
      //     return {
      //       bestPerformingClientName: item.name,
      //       bestPerformingClientCountry: item.country
      //     }
      //   })
      //   data.bestSupplierPartner = supplier.map(item => {
      //     return {
      //       bestPerformerSupplierPartnerName: item.name,
      //       bestPerformerSupplierPartnerCountry: item.country
      //     }
      //   })
      // }
    }

    const verifyClientInfo = (value, data) => {
      console.log('verifyClientInfo:', value, data)
      const { sourceOfCust, countryOfCust, suppliersCountry } = value || state.clientInfo
      if (sourceOfCust.length !== 0 && countryOfCust.length !== 0 && suppliersCountry.length !== 0) {
        if (data) {
          data.sourceOfCust = sourceOfCust
          // data.tradeCountry = countryOfCust
          data.currentSuppliersCountryCode = suppliersCountry
          data.currentClientCountryCode = countryOfCust
        }
      } else {
        // state.clientInfo.icon = null
        return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant_013'))
      }
    }

    const verifyBusinessInfo = (value, data) => {
      console.log('verifyBusinessInfo:', value, data)
      const { wealthSource, sourceFunds, bizCountry, companyWebsite, openingPurpose, businessNatureType, natures, webSiteOrApp, bizScopeDesc, monthlyTxnCount, monthlyTxnEst, otherAccountPath, shopProofPath } = value || state.businessInfo
      if (businessNatureType.length === 0 || natures.length === 0 || !monthlyTxnCount || !monthlyTxnEst || bizCountry.length === 0) {
        // state.businessInfo.icon = null
        console.log('verifyBusinessInfo error 1')
        return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant2_038'))
      }

      // if (businessNatureType.includes('2') && shopProofPath.length === 0) {
      //   // state.businessInfo.icon = null
      //   console.log('verifyBusinessInfo error 2')
      //   return (i18n.global.t('common_text_047') + i18n.global.t('pages_merchant2_038'))
      // }

      if (data) {
        data.openingPurpose = openingPurpose
        data.serviceProvided = businessNatureType
        data.natures = natures
        data.companyWebsite = companyWebsite
        data.enterURLOrAppName = webSiteOrApp
        data.bizScopeDesc = bizScopeDesc
        data.permonthTransactionNumber = monthlyTxnCount
        data.permonthTransactionAmount_v_two = monthlyTxnEst
        data.otherAccountPath = otherAccountPath
        data.shopProofPath = shopProofPath
        data.companyWebsite = companyWebsite
        data.allCountry = bizCountry
        data.sourceFunds = sourceFunds
        data.wealthSource = wealthSource
      }
    }

    const handleFinish = async () => {
      const data = {}
      const errors = []
      errors.push(verifyCompanyNameInfo(null, data))
      errors.push(verifyParentCompanyInfo(null, data))
      errors.push(verifyBranchOfficeSubsidiary(null, data))
      errors.push(verifyBusinessLicenseInfo(null, data))
      errors.push(verifyBusinessAddress(null, data))
      errors.push(verifyIdentityInfo(null, data))
      errors.push(verifyPersonInfo(null, data))
      errors.push(verifyResolutionPower(null, data))
      errors.push(verifySourceFundsInfo(null, data))
      errors.push(verifySourceWhereabouts(null, data))
      errors.push(verifyOtherInfo(null, data))
      errors.push(verifyDeclareInfo(null, data))
      errors.push(verifyEddRefuseInfo(null, data))
      errors.push(verifyClientInfo(null, data))
      errors.push(verifyBusinessInfo(null, data))
      errors.push(verifyLegalVideo(null, data))

      if (errors.some(item => item)) {
        console.log('errors:', errors)
        message.error(errors.filter(item => item).join(''))
        return
      }

      submitRef.value.loading = true
      const res = await _user.approveMaterial(data)
      submitRef.value.loading = false
      if (res.data.succ) {
        message.success(i18n.global.t('pages_merchant_105'))
        router.replace({ path: 'guide_success', query: { isBack: true }})
      } else if (res.data.resCode === '010039') {
        message.error(i18n.global.t('pages_merchant_106'))
      } else {
        message.error(res.data.resMsg)
      }
    }

    const countryChange = () => {
      state.identityInfo.customerIdentity = ['3']
      identityChange()
    }

    const identityChange = () => {
      if (state.refused) return
      const attrs = ['customer', 'legalPerson', 'directorPerson', 'shareholder']
      for (const attr of attrs) {
        state.personalInfo[attr] = [{
          collDisable: false, // attr !== 'customer',
          certificateType: '', // 0: 身份证 1: 护照
          nationality: '',
          idNumber: '',
          passportNumber: '',
          name: '',
          birthDate: '',
          certificateIssueDate: '',
          certificateDate: '',
          idPicFrontPath: [],
          idPicBackPath: [],
          passportPicPath: [],
          addressProofPath: [],
          holdingRatio: ''
        }]
      }
    }

    const initPage = async () => {
      const res = await _home.getMerchantInfo()
      if (res.data.succ) {
        const { status, merchantNo } = res.data.data
        state.merchantNo = merchantNo
        if (status === 'CUSTREJ') loadMerchantInfo()
        else loadTemporaryValue()
      }
      loadAreaPub()
      // await loadKycVideo()
    }

    const loadKycVideo = async () => {
      const res = await _user.getKycVideo()
      if (res.data.succ) {
        const { data } = res.data
        if (data) {
          state.videoInfos.legalVideoPath = [data]
        }
      }
    }

    const loadMerchantInfo = async () => {
      const res = await _user.getRejectCustomerKyc()
      if (res.data.succ) {
        const { data } = res.data
        state.refused = true
        if (data.levelFlag === '1') state.risked = true
        dealMerchantInfo(data.merchantInfo, data.rejectFileName)
      }
    }

    const loadTemporaryValue = async () => {
      const res = await _user.getTemporaryValue({ key: state.merchantNo })
      if (res.data.succ) {
        const { data } = res.data
        if (data) {
          const info = JSON.parse(data)
          state.selectedKeys = [info.stepName || '1-1']
          if (info.companyNameInfo) state.companyNameInfo = info.companyNameInfo
          if (info.parentCompanyInfo) state.parentCompanyInfo = info.parentCompanyInfo
          if (info.branchOfficeSubsidiary) state.branchOfficeSubsidiary = info.branchOfficeSubsidiary
          if (info.businessAddress) state.businessAddress = info.businessAddress
          if (info.businessLicenseInfo) state.businessLicenseInfo = info.businessLicenseInfo
          if (info.identityInfo) state.identityInfo = info.identityInfo
          if (info.personalInfo) state.personalInfo = info.personalInfo
          if (info.resolutionPower) state.resolutionPower = info.resolutionPower
          if (info.sourceFundsInfo) state.sourceFundsInfo = info.sourceFundsInfo
          if (info.sourceWhereabouts) state.sourceWhereabouts = info.sourceWhereabouts
          if (info.declareInfo) state.declareInfo = info.declareInfo
          if (info.eddRefuseInfo) state.eddRefuseInfo = info.eddRefuseInfo
          if (info.otherInfo) state.otherInfo = info.otherInfo
          if (info.clientInfo) state.clientInfo = info.clientInfo
          if (info.businessInfo) state.businessInfo = info.businessInfo
          if (info.stepIcons) {
            state.stepIcons = info.stepIcons
          }
        }
      }
    }

    const loadAreaPub = async () => {
      const data = {
        pageNo: 1,
        pageSize: 10,
        request: {
          countryCode: null,
          riskLevel: '7'
        }
      }
      const resNot = await _receive.getNotAreaPub(data)
      if (resNot.data.succ) {
      // 提取中文部分
        state.notcountries = resNot.data.data.results.map(item => {
          const match = item.countryName.match(/[\u4e00-\u9fa5]+/)
          return match ? match[0] : ''
        })
      }

      const res = await _receive.getAreaPub()
      if (res.data.succ) {
        state.countries = res.data.data.filter(item => {
          return !state.notcountries.includes(item.areaChineseName)
        })
      }
    }

    const setTemporaryValue = () => {
      const data = {
        stepName: state.selectedKeys[0],
        merchantNo: state.merchantNo,
        companyNameInfo: state.companyNameInfo,
        parentCompanyInfo: state.parentCompanyInfo,
        branchOfficeSubsidiary: state.branchOfficeSubsidiary,
        businessAddress: state.businessAddress,
        businessLicenseInfo: state.businessLicenseInfo,
        resolutionPower: state.resolutionPower,
        identityInfo: state.identityInfo,
        personalInfo: state.personalInfo,
        sourceFundsInfo: state.sourceFundsInfo,
        sourceWhereabouts: state.sourceWhereabouts,
        declareInfo: state.declareInfo,
        eddRefuseInfo: state.eddRefuseInfo,
        otherInfo: state.otherInfo,
        clientInfo: state.clientInfo,
        businessInfo: state.businessInfo,
        stepIcons: state.stepIcons
      }
      _user.setTemporaryValue({
        key: state.merchantNo,
        value: JSON.stringify(data)
      })
    }

    const isValidStr = (str) => {
      return str && str.trim().length > 0
    }

    const dealMerchantInfo = (merchantInfo, rejectFileName) => {
      const { countryCode } = merchantInfo
      state.refuseAttrs = Object.keys(rejectFileName)

      const getIconState = (checkFields) => {
        for (const field in checkFields) {
          if (isValidStr(rejectFileName[field])) {
            return 3
          }
        }
        return 2
      }

      const processCompanyNameInfo = () => {
        const { countryCode, merchantNameEn, merchantName } = merchantInfo
        state.stepIcons.companyNameInfo = getIconState({ countryCode, merchantNameEn, merchantName })
        state.companyNameInfo = {
          countryCode,
          countryCodeDisabled: !isValidStr(rejectFileName['countryCode']),
          countryCodeMessage: rejectFileName['countryCode'],
          merchantNameEn,
          merchantNameEnDisabled: !isValidStr(rejectFileName['merchantNameEn']),
          merchantNameEnMessage: rejectFileName['merchantNameEn'],
          merchantNameCn: merchantName,
          merchantNameCnDisabled: !isValidStr(rejectFileName['merchantName']),
          merchantNameCnMessage: rejectFileName['merchantName']
        }
      }

      const processParentCompanyInfo = () => {
        const { isParentCertificate, parentCertificate, ownerShipPath, parentCertificatePath, parentNar1Path, parentUboCerPath, parentHasLicense } = merchantInfo
        state.stepIcons.parentCompanyInfo = getIconState({ isParentCertificate, parentCertificate, ownerShipPath, parentCertificatePath, parentNar1Path, parentUboCerPath, parentHasLicense })
        state.parentCompanyInfo = {
          radioShow: isParentCertificate,
          radioShowDisabled: !isValidStr(rejectFileName['isParentCertificate']),
          radioShowMessage: rejectFileName['isParentCertificate'],
          ownerShipPath: ownerShipPath || [],
          ownerShipPathDisabled: !isValidStr(rejectFileName['ownerShipPath']),
          ownerShipPathMessage: rejectFileName['ownerShipPath'],
          parentCertificatePath: parentCertificatePath,
          certificatePathDisabled: !isValidStr(rejectFileName['parentCertificatePath']),
          certificatePathMessage: rejectFileName['parentCertificatePath'],
          tradeCountry: parentCertificate || [],
          tradeCountryDisabled: !isValidStr(rejectFileName['parentCertificate']),
          tradeCountryMessage: rejectFileName['parentCertificate'],
          parentNar1Path: parentNar1Path || [],
          parentNar1PathDisabled: !isValidStr(rejectFileName['parentNar1Path']),
          parentNar1PathMessage: rejectFileName['parentNar1Path'],
          parentUboCerPath: parentUboCerPath || [],
          parentUboCerPathDisabled: !isValidStr(rejectFileName['parentUboCerPath']),
          parentUboCerPathMessage: rejectFileName['parentUboCerPath'],
          // parentDirectIncumPath: parentDirectIncumPath || [],
          // parentDirectIncumPathDisabled: !isValidStr(rejectFileName['parentDirectIncumPath']),
          // parentDirectIncumPathMessage: rejectFileName['parentDirectIncumPath'],
          parentHasLicense,
          parentHasLicenseDisabled: !isValidStr(rejectFileName['parentHasLicense']),
          parentHasLicenseMessage: rejectFileName['parentHasLicense']
        }
      }

      const processBranchOfficeSubsidiary = () => {
        const { isResides, resides, branchCompanyCertificatePath } = merchantInfo
        state.stepIcons.branchOfficeSubsidiary = getIconState({ isResides, resides, branchCompanyCertificatePath })
        state.branchOfficeSubsidiary = {
          branchRadio: isResides,
          branchRadioDisabled: !isValidStr(rejectFileName['isResides']),
          branchRadioMessage: rejectFileName['isResides'],
          tradeCountry: resides,
          tradeCountryDisabled: !isValidStr(rejectFileName['resides']),
          tradeCountryMessage: rejectFileName['resides'],
          branchCompanyCertificatePath: branchCompanyCertificatePath || [],
          branchCompanyCertificatePathDisabled: !isValidStr(rejectFileName['branchCompanyCertificatePath']),
          branchCompanyCertificatePathMessage: rejectFileName['branchCompanyCertificatePath']
        }
      }

      const processBusinessLicenseInfo = () => {
        const { merchantRegistrationType, businessLicensePath, incorporationPath, establishDate, brExpiryDate, registrationAddress, dirUBOChangeInYear, companyCertificateCINumber,
          businessLicenseCertificateNumber, companyRegistrationCertificateNumber, businessRegistrationNumber, businessRegistrationCertificatePath,
          taxNo, companyCertificatePath, nnc1Path2, mermorandumPath, shareCerPath, goodstandPath, nar1Path2, regApplyPath, proxyProfPath, directIncumPath, sourceFundsPath, companyAdditionalPath, taxLicensePath, annualReturnPath } = merchantInfo

        state.stepIcons.businessLicenseInfo = getIconState({ merchantRegistrationType, businessLicensePath, incorporationPath, establishDate, brExpiryDate, registrationAddress, companyCertificateCINumber,
          businessLicenseCertificateNumber, companyRegistrationCertificateNumber, businessRegistrationNumber, businessRegistrationCertificatePath,
          taxNo, companyCertificatePath, nnc1Path2, mermorandumPath, shareCerPath, goodstandPath, nar1Path2, sourceFundsPath })
        state.businessLicenseInfo = {
          bizRegDate: establishDate,
          bizRegDateDisabled: !isValidStr(rejectFileName['establishDate']),
          bizRegDateMessage: rejectFileName['establishDate'],
          bizRegExpDate: brExpiryDate,
          bizRegExpDateDisabled: !isValidStr(rejectFileName['brExpiryDate']),
          bizRegExpDateMessage: rejectFileName['brExpiryDate'],
          registrationAddress,
          registrationAddressDisabled: !isValidStr(rejectFileName['registrationAddress']),
          registrationAddressMessage: rejectFileName['registrationAddress'],
          merchantRegistrationType,
          companyTypeDisabled: !isValidStr(rejectFileName['merchantRegistrationType']),
          companyTypeMessage: rejectFileName['merchantRegistrationType'],
          bizRegID: countryCode === 'HK' ? businessRegistrationNumber : countryCode === 'CN' ? businessLicenseCertificateNumber : companyRegistrationCertificateNumber,
          bizRegIDDisabled: !isValidStr(rejectFileName['businessLicenseCertificateNumber']) && !isValidStr(rejectFileName['companyRegistrationCertificateNumber']) && !isValidStr(rejectFileName['businessRegistrationNumber']),
          bizRegIDMessage: rejectFileName['businessLicenseCertificateNumber'] || rejectFileName['companyRegistrationCertificateNumber'] || rejectFileName['businessRegistrationNumber'],
          incorporationPath: incorporationPath || [],
          incorporationPathDisabled: !isValidStr(rejectFileName['incorporationPath']),
          incorporationPathMessage: rejectFileName['incorporationPath'],
          dirUBOChangeInYear,
          dirUBOChangeInYearDisabled: !isValidStr(rejectFileName['dirUBOChangeInYear']),
          dirUBOChangeInYearMessage: rejectFileName['dirUBOChangeInYear'],
          ciNumber: companyCertificateCINumber,
          ciNumberDisabled: !isValidStr(rejectFileName['companyCertificateCINumber']),
          ciNumberMessage: rejectFileName['companyCertificateCINumber'],
          taxNo,
          taxNoDisabled: !isValidStr(rejectFileName['taxNo']),
          taxNoMessage: rejectFileName['taxNo'],
          ciPath: companyCertificatePath || [],
          ciPathDisabled: !isValidStr(rejectFileName['companyCertificatePath']),
          ciPathMessage: rejectFileName['companyCertificatePath'],
          bizRegProofPath: countryCode === 'HK' ? businessRegistrationCertificatePath : countryCode === 'CN' ? businessLicensePath : incorporationPath,
          bizRegProofPathDisabled: !isValidStr(rejectFileName['businessRegistrationCertificatePath']) && !isValidStr(rejectFileName['businessLicensePath']) && !isValidStr(rejectFileName['incorporationPath']),
          bizRegProofPathMessage: rejectFileName['businessRegistrationCertificatePath'] || rejectFileName['businessLicensePath'] || rejectFileName['incorporationPath'],
          nnc1Path2: nnc1Path2 || [],
          nnc1PathDisabled: !isValidStr(rejectFileName['nnc1Path2']),
          nnc1PathMessage: rejectFileName['nnc1Path2'],
          corpConstPath: mermorandumPath || [],
          corpConstPathDisabled: !isValidStr(rejectFileName['mermorandumPath']),
          corpConstPathMessage: rejectFileName['mermorandumPath'],
          shareCerPath: shareCerPath || [],
          shareCerPathDisabled: !isValidStr(rejectFileName['shareCerPath']),
          shareCerPathMessage: rejectFileName['shareCerPath'],
          goodStandingPath: goodstandPath || [],
          goodStandingPathDisabled: !isValidStr(rejectFileName['goodstandPath']),
          goodStandingPathMessage: rejectFileName['goodstandPath'],
          nar1Path2: nar1Path2 || [],
          nar1PathDisabled: !isValidStr(rejectFileName['nar1Path2']),
          nar1PathMessage: rejectFileName['nar1Path2'],
          regApplyPath: regApplyPath || [],
          regApplyPathDisabled: !isValidStr(rejectFileName['regApplyPath']),
          regApplyPathMessage: rejectFileName['regApplyPath'],
          proxyProfPath: proxyProfPath || [],
          proxyProfPathDisabled: !isValidStr(rejectFileName['proxyProfPath']),
          proxyProfPathMessage: rejectFileName['proxyProfPath'],
          directIncumPath: directIncumPath || [],
          directIncumPathDisabled: !isValidStr(rejectFileName['directIncumPath']),
          directIncumPathMessage: rejectFileName['directIncumPath'],
          sourceFundsPath: sourceFundsPath || [],
          sourceFundsPathDisabled: !isValidStr(rejectFileName['sourceFundsPath']),
          sourceFundsPathMessage: rejectFileName['sourceFundsPath'],
          companyAdditionalPath: companyAdditionalPath || [],
          companyAdditionalPathDisabled: !isValidStr(rejectFileName['companyAdditionalPath']),
          companyAdditionalPathMessage: rejectFileName['companyAdditionalPath'],
          taxLicensePath: taxLicensePath || [],
          taxLicensePathDisabled: !isValidStr(rejectFileName['taxLicensePath']),
          taxLicensePathMessage: rejectFileName['taxLicensePath'],
          annualReturnPath: annualReturnPath || [],
          annualReturnPathDisabled: !isValidStr(rejectFileName['annualReturnPath']),
          annualReturnPathMessage: rejectFileName['annualReturnPath']
        }
      }

      const processBusinessAddress = () => {
        const { companyAddressType, mailingAddress, proofOfRealBusinessAddress } = merchantInfo
        state.stepIcons.businessAddress = getIconState({ companyAddressType, mailingAddress, proofOfRealBusinessAddress })
        state.businessAddress = {
          companyAddressType,
          companyAddressTypeDisabled: !isValidStr(rejectFileName['companyAddressType']),
          companyAddressTypeMessage: rejectFileName['companyAddressType'],
          realCompanyAddress: mailingAddress,
          realCompanyAddressDisabled: !isValidStr(rejectFileName['mailingAddress']),
          realCompanyAddressMessage: rejectFileName['mailingAddress'],
          bizAddrPath: proofOfRealBusinessAddress || [],
          bizAddrPathDisabled: !isValidStr(rejectFileName['proofOfRealBusinessAddress']),
          bizAddrPathMessage: rejectFileName['proofOfRealBusinessAddress']
        }
      }

      const processIdentityInfo = () => {
        const { customerIdentity } = merchantInfo
        state.stepIcons.identityInfo = getIconState({ customerIdentity })
        state.identityInfo = {
          customerIdentity,
          customerIdentityDisabled: !isValidStr(rejectFileName['customerIdentity']),
          customerIdentityMessage: rejectFileName['customerIdentity']
        }
      }

      const processPersonalInfo = () => {
        const buildPerson = (item) => {
          return {
            certificateType: item.type,
            nationality: item.issuancePlace,
            idNumber: item.idNumber,
            passportNumber: item.idNumber,
            name: item.name,
            birthDate: item.dateOfBirth,
            certificateIssueDate: item.issueDate,
            certificateDate: item.expiryDate,
            idPicFrontPath: (item.type === '0' && item.path[0]) ? [item.path[0]] : [],
            idPicBackPath: (item.type === '0' && item.path[1]) ? [item.path[1]] : [],
            passportPicPath: (item.type === '1' && item.path.length !== 0) ? item.path : [],
            holdingRatio: item.holdRatio
          }
        }

        const { customerIdentity, customer, legalPerson, director, shareholder, idnumberOfAuthorizedPerson, authorizedPerson, authorizersCerIssueDate, dateOfBirthOfAuthorizedPerson, authorizersCertificateDate, directorAddressProofPath } = merchantInfo
        state.stepIcons.personalInfo = getIconState({ customer, legalPerson, director, shareholder, idnumberOfAuthorizedPerson, authorizedPerson, authorizersCerIssueDate, dateOfBirthOfAuthorizedPerson, authorizersCertificateDate, directorAddressProofPath })

        const processCustomerHoldRatio = () => {
          // check identity type
          if (customerIdentity.includes('2') && shareholder && shareholder.length > 0) {
            return shareholder[0].holdRatio
          }
        }

        const processCustomer = () => {
          const item = customer[0]
          return [{
            certificateType: item.type,
            nationality: item.issuancePlace,
            idNumber: idnumberOfAuthorizedPerson,
            passportNumber: idnumberOfAuthorizedPerson,
            name: authorizedPerson,
            birthDate: dateOfBirthOfAuthorizedPerson,
            certificateIssueDate: authorizersCerIssueDate,
            certificateDate: authorizersCertificateDate,
            idPicFrontPath: (item.type === '0' && item.path[0]) ? [item.path[0]] : [],
            idPicBackPath: (item.type === '0' && item.path[1]) ? [item.path[1]] : [],
            passportPicPath: (item.type === '1' && item.path.length !== 0) ? item.path : [],
            holdingRatio: processCustomerHoldRatio()
          }]
        }

        state.personalInfo = {
          personalInfoDisabled: !(isValidStr(rejectFileName['customer']) ||
                                isValidStr(rejectFileName['legalPerson']) ||
                                isValidStr(rejectFileName['director']) ||
                                isValidStr(rejectFileName['shareholder'])),
          customer: processCustomer(),
          customerMessage: rejectFileName['customer'],
          legalPerson: legalPerson ? legalPerson.map(item => buildPerson(item)) : [],
          legalPersonMessage: rejectFileName['legalPerson'],
          directorPerson: director ? director.map(item => buildPerson(item)) : [],
          directorPersonMessage: rejectFileName['director'],
          shareholder: shareholder ? shareholder.map(item => buildPerson(item)) : [],
          shareholderMessage: rejectFileName['shareholder'],
          directorAddressProofPath: directorAddressProofPath || [],
          directorAddressProofPathDisabled: !isValidStr(rejectFileName['directorAddressProofPath']),
          directorAddressProofPathMessage: rejectFileName['directorAddressProofPath']
        }
      }

      const processResolutionPower = () => {
        const { authorizationPath } = merchantInfo
        state.stepIcons.resolutionPower = getIconState({ authorizationPath })
        state.resolutionPower = {
          authorizationPath,
          authorizationPathDisabled: !isValidStr(rejectFileName['authorizationPath']),
          authorizationPathMessage: rejectFileName['authorizationPath']
        }
      }

      const processSourceFundsInfo = () => {
        // const { wealthSource } = merchantInfo
        // state.stepIcons.sourceFundsInfo = getIconState({ wealthSource })
        // state.sourceFundsInfo = {
        //   sourceFunds: wealthSource || [],
        //   sourceFundsDisabled: !isValidStr(rejectFileName['wealthSource']),
        //   sourceFundsMessage: rejectFileName['wealthSource']
        // }
      }

      const processSourceWhereabouts = () => {
        const { paymentPurpose } = merchantInfo
        state.stepIcons.sourceWhereabouts = getIconState({ paymentPurpose })
        state.sourceWhereabouts = {
          paymentPurpose: paymentPurpose || [],
          paymentPurposeDisabled: !isValidStr(rejectFileName['paymentPurpose']),
          paymentPurposeMessage: rejectFileName['paymentPurpose']
        }
      }

      const processOtherInfo = () => {
        const { accessories, supplyText } = merchantInfo
        state.stepIcons.otherInfo = getIconState({ accessories, supplyText })
        state.otherInfo = {
          docPath: accessories,
          docPathDisabled: !isValidStr(rejectFileName['accessories']),
          docPathMessage: rejectFileName['accessories'],
          supplyText,
          supplyTextDisabled: !isValidStr(rejectFileName['supplyText']),
          supplyTextMessage: rejectFileName['supplyText']
        }
      }

      const processDeclareInfo = () => {
        const { isRiskCountryTransaction, riskTransaction } = merchantInfo
        state.stepIcons.declareInfo = getIconState({ isRiskCountryTransaction, riskTransaction })
        state.declareInfo = {
          declareRadio: isRiskCountryTransaction,
          declareRadioDisabled: !isValidStr(rejectFileName['isRiskCountryTransaction']),
          declareRadioMessage: rejectFileName['isRiskCountryTransaction'],
          tradeCountry: riskTransaction,
          tradeCountryDisabled: !isValidStr(rejectFileName['riskTransaction']),
          tradeCountryMessage: rejectFileName['riskTransaction']
        }
      }

      const processEddRefuseInfo = () => {
        const { financialStatementsPath, questionnairePath, bestPerforming, bestPerformer } = merchantInfo
        state.stepIcons.eddRefuseInfo = getIconState({ financialStatementsPath, questionnairePath })
        state.eddRefuseInfo = {
          customer: bestPerforming,
          customerDisabled: !isValidStr(rejectFileName['bestPerforming']),
          customerMessage: rejectFileName['bestPerforming'],
          supplier: bestPerformer,
          supplierDisabled: !isValidStr(rejectFileName['bestPerformer']),
          supplierMessage: rejectFileName['bestPerformer'],
          financialStatementsPath,
          statementsPathDisabled: !isValidStr(rejectFileName['financialStatementsPath']),
          statementsPathMessage: rejectFileName['financialStatementsPath'],
          questionnairePath,
          questionnairePathDisabled: !isValidStr(rejectFileName['questionnairePath']),
          questionnairePathMessage: rejectFileName['questionnairePath']
        }
      }

      const processClientInfo = () => {
        const { sourceOfCust, currentClientCountryCode, currentSuppliersCountryCode } = merchantInfo
        state.stepIcons.clientInfo = getIconState({ sourceOfCust, currentClientCountryCode, currentSuppliersCountryCode })
        state.clientInfo = {
          sourceOfCust: sourceOfCust || [],
          sourceOfCustDisabled: !isValidStr(rejectFileName['sourceOfCust']),
          sourceOfCustMessage: rejectFileName['sourceOfCust'],
          countryOfCust: currentClientCountryCode || [],
          countryOfCustDisabled: !isValidStr(rejectFileName['currentClientCountryCode']),
          countryOfCustMessage: rejectFileName['currentClientCountryCode'],
          suppliersCountry: currentSuppliersCountryCode || [],
          suppliersCountryDisabled: !isValidStr(rejectFileName['currentSuppliersCountryCode']),
          suppliersCountryMessage: rejectFileName['currentSuppliersCountryCode']
        }
      }

      const processBusinessInfo = () => {
        const { wealthSource, sourceFunds, openingPurpose, serviceProvided, natures, enterURLOrAppName, bizScopeDesc, permonthTransactionNumber, permonthTransactionAmount_v_two, otherAccountPath, shopProofPath, companyWebsite, allCountry } = merchantInfo
        state.stepIcons.businessInfo = getIconState({ serviceProvided, natures, enterURLOrAppName, bizScopeDesc, permonthTransactionNumber, permonthTransactionAmount_v_two, otherAccountPath, shopProofPath, companyWebsite, allCountry })
        state.businessInfo = {
          openingPurpose: openingPurpose || [],
          openingPurposeDisabled: !isValidStr(rejectFileName['openingPurpose']),
          openingPurposeMessage: rejectFileName['openingPurpose'],
          businessNatureType: serviceProvided || [],
          businessNatureTypeDisabled: !isValidStr(rejectFileName['serviceProvided']),
          businessNatureTypeMessage: rejectFileName['serviceProvided'],
          natures: natures || [],
          naturesDisabled: !isValidStr(rejectFileName['natures']),
          naturesMessage: rejectFileName['natures'],
          webSiteOrApp: enterURLOrAppName,
          webSiteOrAppDisabled: !isValidStr(rejectFileName['enterURLOrAppName']),
          webSiteOrAppMessage: rejectFileName['enterURLOrAppName'],
          bizScopeDesc,
          bizScopeDescDisabled: !isValidStr(rejectFileName['bizScopeDesc']),
          bizScopeDescMessage: rejectFileName['bizScopeDesc'],
          monthlyTxnCount: permonthTransactionNumber,
          monthlyTxnCountDisabled: !isValidStr(rejectFileName['permonthTransactionNumber']),
          monthlyTxnCountMessage: rejectFileName['permonthTransactionNumber'],
          monthlyTxnEst: permonthTransactionAmount_v_two,
          monthlyTxnEstDisabled: !isValidStr(rejectFileName['permonthTransactionAmount_v_two']),
          monthlyTxnEstMessage: rejectFileName['permonthTransactionAmount_v_two'],
          otherAccountPath: otherAccountPath || [],
          otherAccountPathDisabled: !isValidStr(rejectFileName['otherAccountPath']),
          otherAccountPathMessage: rejectFileName['otherAccountPath'],
          shopProofPath: shopProofPath || [],
          shopProofPathDisabled: !isValidStr(rejectFileName['shopProofPath']),
          shopProofPathMessage: rejectFileName['shopProofPath'],
          companyWebsite,
          companyWebsiteDisabled: !isValidStr(rejectFileName['companyWebsite']),
          companyWebsiteMessage: rejectFileName['companyWebsite'],
          bizCountry: allCountry || [],
          wealthSource: wealthSource || [],
          wealthSourceDisabled: !isValidStr(rejectFileName['wealthSource']),
          wealthSourceMessage: rejectFileName['wealthSource'],
          sourceFunds: sourceFunds || [],
          sourceFundsDisabled: !isValidStr(rejectFileName['sourceFunds']),
          sourceFundsMessage: rejectFileName['sourceFunds']
        }
      }

      const processLegalVideo = () => {
        const { legalVideoPath } = merchantInfo
        state.videoInfos = {
          legalVideoPath: legalVideoPath || [],
          legalVideoPathDisabled: !isValidStr(rejectFileName['legalVideoPath']),
          legalVideoPathMessage: rejectFileName['legalVideoPath']
        }

        if (state.videoInfos.legalVideoPathMessage) {
          // reject case, check if user has upload new video
        }

        // 设置图标状态
        state.stepIcons.legalVideo = getIconState({ legalVideoPath })
      }

      processCompanyNameInfo()
      processParentCompanyInfo()
      processBranchOfficeSubsidiary()
      processBusinessLicenseInfo()
      processBusinessAddress()
      processIdentityInfo()
      processPersonalInfo()
      processResolutionPower()
      processSourceFundsInfo()
      processSourceWhereabouts()
      processOtherInfo()
      processDeclareInfo()
      processEddRefuseInfo()
      processClientInfo()
      processBusinessInfo()
      processLegalVideo()
    }

    initPage()

    return {
      submitRef,
      handleNext,
      handleFinish,
      countryChange,
      identityChange,
      loadKycVideo,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#merchantInfo {
  text-align: left;
  .header-nav {
    height: 60px;
    padding: 0 24px;
    margin-bottom: 4px;
    box-shadow: 0 0 6px 0 #d9d9d9;
    img {
      width: 150px;
    }
    .nav-right {
      margin-left: auto;
      cursor: pointer;
      .ic-lanage {
        color: @main-color;
        font-size: 24px;
      }
      .text {
        margin-left: 8px;
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
  .merchant-body {
    display: flex;
    .body-left {
      width: 333px;
      height: calc(100vh - 60px);
      .ic-error {
        color: @error-color;
      }
      .ic-correct {
        color: @success-color;
      }
    }
    .body-left:deep(.ant-menu-inline) {
      background: #fff;
    }
    .body-right {
      .scrollbar-none;
      width: calc(100% - 152px);
      height: calc(100vh - 60px);
      padding: 24px 0 24px 128px;
      overflow: scroll;
    }
    .body-right::-webkit-scrollbar {
      display: none;
    }
    .body-right:deep(.error-area) {
      display: flex;
      padding: 12px 24px;
      border-radius: 5px;
      color: @error-color;
      background: #fef0f0;
      margin-top: 10px;
      text-align: left;
      word-break: break-word;
      .ic-error {
        font-size: 28px;
        margin-right: 12px;
      }
    }
    .body-right:deep(.ant-form-item-label) {
      label {
        font-size: 16px;
      }
    }
  }
}
</style>
